import React, {useContext} from 'react';

import MyDrawer, {drawerWidth} from "./MyDrawer";
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {AuthContext, PageContext} from "@lb/mlib-components";
import Box from "@mui/material/Box";
import {isMobile} from "react-device-detect";
import {Stack} from "@mui/material";


const theme = createTheme();

const Layout = (props) => {

    const pageCtx = useContext(PageContext);
    const pageTitle = pageCtx.title;

    const authCtx = useContext(AuthContext)

    return (<ThemeProvider theme={theme}>
            <Stack direction={isMobile ? "column" : "row"} >
                {authCtx.isLoggedIn() && (
                    <Box sx={{display: 'flex'}}>
                        {pageTitle !== "Dashboard" && pageTitle !== "Today" && pageTitle !== "Future" && pageTitle !== "In Transit" && pageTitle !== "Map" &&
                            <MyDrawer callLoad={props.callLoad}/>}
                    </Box>
                )}

                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        width: {sm: `calc(100% - ${drawerWidth}px)`},
                    }}>
                    {props.children}
                </Box>
            </Stack>

        </ThemeProvider>
    )
        ;
};

export default Layout;
